/**
 * WalletVault Constants
 */

export const STORAGE_KEY = 'pf-wallet-vault';
export const STORAGE_KEY_ENCRYPTED = 'pf-wallet-vault-encrypted';
export const STORAGE_KEY_SALT = 'pf-wallet-vault-salt';
export const STORAGE_KEY_AUTH_TYPE = 'pf-wallet-vault-auth-type';
export const VAULT_VERSION = '2.0.0';
export const AUTO_LOCK_MS = 15 * 60 * 1000; // 15 minutes

// Authentication types
export const AUTH_TYPES = {
  PASSWORD: 'password',
  SIGNATURE: 'signature'
};

// Wallet categories
export const WALLET_CATEGORIES = {
  BUNDLE: 'bundle',
  AGED: 'aged',
  PROFIT: 'profit',
  AIRDROP: 'airdrop',
  MAIN: 'main',
  RESERVE: 'reserve',
  ISOLATED: 'isolated',
  HOP: 'hop'  // Mixer hop wallets
};

// Wallet status
export const WALLET_STATUS = {
  ACTIVE: 'active',
  AGING: 'aging',
  READY: 'ready',
  USED: 'used',
  ARCHIVED: 'archived'
};
